import { useContext, useCallback } from "react";
import { trackContext } from "../components/Tracker";

export const eventTypes = {
	PAGE_LOAD: "PAGE_LOAD",
	SHOW_ORDER_CLICK: "SHOW_ORDER_CLICK",

	COOPJS_SCROLL_WIDGET_CLICK: "COOPJS_SCROLL_WIDGET_CLICK",
	COOPJS_REWARDS_CLAIM_CLICK: "COOPJS_REWARDS_CLAIM_CLICK",
	COOPJS_COLLECTIVE_CLICK: "COOPJS_COLLECTIVE_CLICK",
	COOPJS_COLLECTIVE_OPTED_CLICK: "COOPJS_COLLECTIVE_OPTED_CLICK",

	WIDGET_CONTACT_US_CLICK: "WIDGET_CONTACT_US_CLICK",
	WIDGET_TRACK_ORDER_CLICK: "WIDGET_TRACK_ORDER_CLICK",

	WIDGET_SHOP_INSTA_CLICK: "WIDGET_SHOP_INSTA_CLICK",
	WIDGET_SHOP_TWITTER_CLICK: "WIDGET_SHOP_TWITTER_CLICK",
	WIDGET_SHOP_FB_CLICK: "WIDGET_SHOP_FB_CLICK",

	WIDGET_DISPLAY: "WIDGET_DISPLAY",
	WIDGET_BRAND_DISPLAY: "WIDGET_BRAND_DISPLAY",
	WIDGET_LOAD: "WIDGET_LOAD",

	WIDGET_EMAIL_CLICK: "WIDGET_EMAIL_CLICK",
	WIDGET_SMS_CLICK: "WIDGET_SMS_CLICK",
	WIDGET_EMAIL_SEND: "WIDGET_EMAIL_SEND",
	WIDGET_SMS_SEND: "WIDGET_SMS_SEND",

	WIDGET_SURVEY_DISPLAY: "WIDGET_SURVEY_DISPLAY",
	WIDGET_SURVEY_MODAL_DISPLAY: "WIDGET_SURVEY_MODAL_DISPLAY",
	WIDGET_SURVEY_CLICK: "WIDGET_SURVEY_CLICK",
	WIDGET_SURVEY_MODAL_CLICK: "WIDGET_SURVEY_MODAL_CLICK",
	WIDGET_SURVEY_MODAL_SKIP: "WIDGET_SURVEY_MODAL_SKIP",
	WIDGET_SURVEY_NO_ORDER: "WIDGET_SURVEY_NO_ORDER",

	WIDGET_SURFACE_SURVEY_DISPLAY: "WIDGET_SURFACE_SURVEY_DISPLAY",
	WIDGET_SURFACE_SURVEY_CLICK: "WIDGET_SURFACE_SURVEY_CLICK",
	WIDGET_SURFACE_SURVEY_SKIP: "WIDGET_SURFACE_SURVEY_SKIP",

	WIDGET_SURFACE_OFFER_DISPLAY: "WIDGET_SURFACE_OFFER_DISPLAY",
	WIDGET_SURFACE_OFFER_CLICK: "WIDGET_SURFACE_OFFER_CLICK",
	WIDGET_SURFACE_OFFER_BACK_CLICK: "WIDGET_SURFACE_OFFER_BACK_CLICK",
	WIDGET_SURFACE_OFFER_REDEEM_CLICK: "WIDGET_SURFACE_OFFER_REDEEM_CLICK",
	WIDGET_SURFACE_OFFER_TIMER_END: "WIDGET_SURFACE_OFFER_TIMER_END",
	WIDGET_SURFACE_OFFER_SKIP: "WIDGET_SURFACE_OFFER_SKIP",

	WIDGET_SURFACE_REWARD_DISPLAY: "WIDGET_SURFACE_REWARD_DISPLAY",
	WIDGET_SURFACE_REWARD_CLICK: "WIDGET_SURFACE_REWARD_CLICK",
	WIDGET_SURFACE_REWARD_SKIP: "WIDGET_SURFACE_REWARD_SKIP",
	WIDGET_SURFACE_REWARD_EMAIL_SUBMIT: "WIDGET_SURFACE_REWARD_EMAIL_SUBMIT",

	WIDGET_SURFACE_CUSTOM_POST_DISPLAY: "WIDGET_SURFACE_CUSTOM_POST_DISPLAY",

	WIDGET_SURFACE_PRODUCT_SHARE: "WIDGET_SURFACE_PRODUCT_SHARE",

	WIDGET_OFFER_MODAL_DISPLAY: "WIDGET_OFFER_MODAL_DISPLAY",
	WIDGET_OFFER_MODAL_CLICK: "WIDGET_OFFER_MODAL_CLICK",
	WIDGET_OFFER_MODAL_BACK_CLICK: "WIDGET_OFFER_MODAL_BACK_CLICK",
	WIDGET_OFFER_MODAL_REDEEM_CLICK: "WIDGET_OFFER_MODAL_REDEEM_CLICK",
	WIDGET_OFFER_MODAL_TIMER_END: "WIDGET_OFFER_MODAL_TIMER_END",
	WIDGET_OFFER_MODAL_SKIP: "WIDGET_OFFER_MODAL_SKIP",

	WIDGET_REWARD_MODAL_DISPLAY: "WIDGET_REWARD_MODAL_DISPLAY",
	WIDGET_REWARD_MODAL_CLICK: "WIDGET_REWARD_MODAL_CLICK",
	WIDGET_REWARD_MODAL_SKIP: "WIDGET_REWARD_MODAL_SKIP",
	WIDGET_REWARD_EMAIL_SUBMIT: "WIDGET_REWARD_EMAIL_SUBMIT",

	WIDGET_CUSTOM_POST_DISPLAY: "WIDGET_CUSTOM_POST_DISPLAY",

	WIDGET_PDP_OPEN: "WIDGET_PDP_OPEN", // done
	WIDGET_PDP_CLOSE: "WIDGET_PDP_CLOSE", // done
	WIDGET_PDP_DISPLAY: "WIDGET_PDP_DISPLAY", // done
	WIDGET_PDP_IMAGE_CLICK: "WIDGET_PDP_IMAGE_CLICK", // done
	WIDGET_PDP_PRODUCT_DETAIL_CLICK: "WIDGET_PDP_PRODUCT_DETAIL_CLICK", // done
	WIDGET_PDP_BRAND_DETAIL_CLICK: "WIDGET_PDP_BRAND_DETAIL_CLICK", // done
	WIDGET_PDP_SIMILAR_PRODUCT_DISPLAY: "WIDGET_PDP_SIMILAR_PRODUCT_DISPLAY", // done
	WIDGET_PDP_SIMILAR_PRODUCT_CLICK: "WIDGET_PDP_SIMILAR_PRODUCT_CLICK", // done
	WIDGET_PDP_SHARE: "WIDGET_PDP_SHARE", // done => all properties similar to PRODUCT_DISPLAY EVENT IN PDP
	WIDGET_PDP_VARIANT_SCREEN_OPEN: "WIDGET_PDP_VARIANT_SCREEN_OPEN", // done => all properties similar to PRODUCT_DISPLAY EVENT IN PDP => DISTINGUISH BETWEEN A SELECT DETAIL CLICK AND ACTUAL BUTTON CLICK
	WIDGET_PDP_VARIANT_SCREEN_CLOSE: "WIDGET_PDP_VARIANT_SCREEN_CLOSE", // done => all properties similar to PRODUCT_DISPLAY EVENT IN PDP
	WIDGET_PDP_CHECKOUT_CLICK: "WIDGET_PDP_CHECKOUT_CLICK", // done => { parameter to distinguish b/w ariant =>>>> variant_screen: bool} | EXACT VARIANT ID OF THE PRODUCT | THE QUANTITY

	CLICK_BRAND: "CLICK_BRAND",
	CLICK: "CLICK",
	UPSELL_CLICK: "UPSELL_CLICK",

	WIDGET_OFFER_CLICK: "WIDGET_OFFER_CLICK", // for the inline brand offer button
	WIDGET_COOP_LOGO_CLICK: "WIDGET_COOP_LOGO_CLICK",
	WIDGET_SEE_MORE_CLICK: "WIDGET_SEE_MORE_CLICK",
};

export default function useTrack() {
	const push = useContext(trackContext);
	const track = useCallback(
		(name, properties = {}) => {
			if (!(name in eventTypes)) {
				return false;
			}

			push({
				name,
				properties,
			});
			return true;
		},
		[push]
	);
	return track;
}
